import { ViewIndivSvg } from "../../inlinesvgs/ViewIndivSvg";
import { UnlockAllSvg } from "../../inlinesvgs/UnlockAllSvg";
import { I18N } from "oc-I18N";
import { useState } from "react";

const toggleTitle = I18N("Individualisierte Parts anzeigen An/Aus");
const aufhebenTitle = I18N("Alle Individualisierungen aufheben");

export function IndividualAuswahlwerteButtons() {
  const [on, setOn] = useState(false);
  const isActiveIndivAnzeigen =
    APP.arrangement.isIndividualisierteParts &&
    !APP.arrangement.selectedObjects.some((o) => o.isPfosten || o.isElement);
  const isActiveIndivAufheben = APP.arrangement.isIndividualisierteParts;
  return (
    <div className="flex-row undo-redo-buttons">
      <button
        className={`svg-button-dotted ${isActiveIndivAnzeigen ? "active" : ""} ${on ? "on" : "off"}`}
        title={toggleTitle}
        aria-label={toggleTitle}
        data-button-key={`show-individualisierte-auswahlwerte-${on ? "on" : "off"}`}
        onClick={() => {
          APP.arrangement.toggleShowIndividualisierteAuswahlwerte(!on);
          setOn(!on);
        }}
      >
        <ViewIndivSvg />
      </button>
      <button
        className={`svg-button-dotted ${isActiveIndivAufheben ? "active" : ""}`}
        title={aufhebenTitle}
        aria-label={aufhebenTitle}
        data-button-key="individualisierung-aufheben"
        onClick={() => {
          APP.arrangement.resetIndividualisierteAuswahlwerte();
          APP.logUserAction({ action: "resetIndividualisierteAuswahlwerte" });
        }}
      >
        <UnlockAllSvg />
      </button>
    </div>
  );
}
